module.exports = __webpack_public_path__ + "static/media/18ECA50.b3b01d46.jpg";